module.exports = __webpack_public_path__ + "img/robert-lewandowski.5f43e047.png";